import { render, staticRenderFns } from "./DictionaryWordsIndex.vue?vue&type=template&id=2231e8fa&scoped=true&"
import script from "./DictionaryWordsIndex.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryWordsIndex.vue?vue&type=style&index=0&id=2231e8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231e8fa",
  null
  
)

export default component.exports